export { type Sentence, sentenceTable } from "#sentence-table";
